import ls from "localstorage-slim";
import { isEmpty, isUndefined } from "lodash";

export interface IProductDataCache {
  getCache(key: string): void;
  saveCache(product: unknown, key: string): void;
  resetCache(key: string): void;
}

export class ProductDataCache implements IProductDataCache {
  getCache(key: string) {
    ls.config.encrypt = true;
    return !isUndefined(JSON.parse(ls.get(key) as string))
      ? JSON.parse(ls.get(key) as string)
      : "";
  }
  saveCache(product: unknown, key: string, needExpired: boolean = true) {
    ls.config.encrypt = true;
    ls.set(key, JSON.stringify(product), needExpired === true && { ttl: 7200 });
  }
  resetCache(key: string) {
    ls.config.encrypt = true;
    let localCache = JSON.parse(ls.get(key) as string) ?? "";
    if (!isEmpty(key)) {
      if (!isEmpty(localCache)) {
        ls.remove(key);
      }
    } else {
      ls.clear();
    }
  }
}

export const productCache = new ProductDataCache();
